import { render, staticRenderFns } from "./CatalogHistory.vue?vue&type=template&id=710b1c3c"
import script from "./CatalogHistory.vue?vue&type=script&lang=js"
export * from "./CatalogHistory.vue?vue&type=script&lang=js"
import style0 from "./CatalogHistory.vue?vue&type=style&index=0&id=710b1c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports